export const SALES_CRM_FEATURE_FLAG = "sales_crm_feature";
